module.exports = __webpack_public_path__ + "images/sam/dt-arrow-up.png";